'use client';
import { useEffect, useState } from 'react';

export function Confetti({ pieces = 300 }) {
  const [confettiPieces, setConfettiPieces] = useState([]);

  useEffect(() => {
    const piecesArray = [];
    const colors = [
      '#002854', // dark blue
      '#405E93', // accent color
      '#CAE3E8', // light blue
      '#E2BBB4', // light pink
      '#F18070', // primary
      '#5AB1DE' // secondary
    ];

    for (let i = 0; i < pieces; i++) {
      piecesArray.push({
        id: i,
        x: Math.random() * 100, // Random horizontal position (percentage)
        color: colors[Math.floor(Math.random() * colors.length)],
        size: Math.random() * 6 + 3, // Random size between 3-9px
        rotation: Math.random() * 360, // Random initial rotation
        animationDelay: Math.random() * 1.5, // Stagger the animations
        duration: Math.random() * 1.5 + 2.5, // Random fall duration 2.5-4 seconds
        shape: Math.random() > 0.5 ? 'square' : 'circle' // Random shape
      });
    }

    setConfettiPieces(piecesArray);
  }, [pieces]);

  return (
    <>
      <style jsx>{`
        @keyframes confetti-fall {
          0% {
            transform: translateY(-100vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }

        .confetti-piece {
          animation: confetti-fall linear forwards;
        }
      `}</style>
      <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
        {confettiPieces.map((piece) => (
          <div
            key={piece.id}
            className={`confetti-piece absolute ${
              piece.shape === 'circle' ? 'rounded-full' : 'rounded-sm'
            }`}
            style={{
              left: `${piece.x}%`,
              top: '-10px',
              backgroundColor: piece.color,
              width: `${piece.size}px`,
              height: `${piece.size}px`,
              transform: `rotate(${piece.rotation}deg)`,
              animationDelay: `${piece.animationDelay}s`,
              animationDuration: `${piece.duration}s`
            }}
          />
        ))}
      </div>
    </>
  );
}
